import React from 'react'
import './Main.css'
import { Container, Row, Col } from 'react-bootstrap';
// IMG
import snowTransport from '../assets/img/transport.png';
import animals from '../assets/img/animals.png';
import app from '../assets/img/app.png';
import rocket from '../assets/img/racket.png'
import food from '../assets/img/food.png'
import abcnetLogo from '../assets/img/abcnet.png'
import toyodaImg from '../assets/img/toyoda.jpeg'
import pneuservis from '../assets/img/pneuservis.png'
import HeroSection from './HeroSection';
import imgGlobalPlusWeb from '../assets/img/globalplusweb.png'
import strazce from '../assets/img/zvirecistrazce.png'
import sorelio from '../assets/img/sorelio.png'
import ProjectCard from './ProjectCard'; // <- nový import
import imgVhs from '../assets/img/vhs.png';
import imgAlfasped from '../assets/img/alfasped.png';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


const wokrProgress = [
    { id: 1, title: 'Konzultace' },
    { id: 2, title: 'Náčrt funkčnosti a design' },
    { id: 3, title: 'Vyhotovení projektu' },
    { id: 4, title: 'Řádné otestování' },
  ];

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const rocketVariants = {
    initial: { scale: 1, x: 0, y: 0 },
    animate: { scale: 2, x: '100vw', y: '-100vh' },
  };


// MAIN
function Main() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1, // Prvek se aktivuje, když je z 10% viditelný
      });


  return (
    <div className='mainContainer' >
        <HeroSection />
        <div className='textContent'>
            <h2>Programy na zakázku, co Vám ušetří spoustu času a peňez.</h2>
            <p><span style={{color: 'rgb(51,154,222)'}}>Mějte svou APPku </span> a to nejen pro prestiž, ale také pro automatizaci a ulehčení administrativě.</p>
            <p><span style={{color: 'rgb(51,154,222)'}}>Webové stránky na míru, co budou reprezentovat Vaší firmu tak jak si to zaslouží.</span> Bez internetu to už ani snad dneska nejde.</p>
        </div>

        {/* === KARTIČKY (pouze tato část je upravená) === */}
        <Container>
            <Row className="gx-3">
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={imgAlfasped}
                        imgAlt="Alfasped – Elektronický systém pro správu kamionů a návštěv"
                        year="2025"
                        title="Alfasped"
                        bullets={[
                            'Elektronický systém pro správu příchozích kamionů a návštěv ve firmě.',
                            'Kiosek pro kamiony přiděluje doky a řídí průjezd areálem.',
                            'Kiosek pro návštěvy zajišťuje registraci a informuje navštívené osoby.',
                            'Psáno v Laravel a React.',
                        ]}
                    />
                </Col>


                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={imgVhs}
                        imgAlt="VHS Holding – web a rezidenční projekt"
                        year="2025"
                        title="VHS Holding" /* nechávám rok nahoře, titulek prázdný = nezobrazí se */
                        bullets={[
                            'Webové stránky pro holding a jejich nejnovejší projekt: Rezidenční bydlení',
                            'Psáno v Laravel a React',
                        ]}
                        linkHref="https://vhsholding.cz"
                    />
                </Col>

                {/* Taxi app */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={app}
                        imgAlt="Objednávkový systém pro taxislužbu"
                        year="2024"
                        title="Taxi app" /* nechávám rok nahoře, titulek prázdný = nezobrazí se */
                        bullets={[
                            'Objednávkový systém pro taxislužbu',
                            'Psáno v react native + php',
                            'Umístěno v APPLE STORE a Google Play',
                        ]}
                        linkHref="https://apps.apple.com/cz/app/global-plus/id6502606357?l=cs"
                        linkText="Link"
                    />
                </Col>

                {/* Zvířecí strážce */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={strazce}
                        imgAlt="Zvířecí strážce – aplikace pro majitele psů a koček"
                        title="Zvířecí strážce"
                        year="2024"
                        bullets={[
                            'Zvířecí strážce',
                            'Aplikace pro IOS, ANDROID a web',
                            'Vše potřebné pro majitele psa, kočky.',
                            'Psáno v Laravel + React Native Expo',
                        ]}
                        linkHref="https://zvirecistrazce.cz"
                        linkText="Link"
                    />
                </Col>

                {/* Transport osob */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={snowTransport}
                        imgAlt="Objednávkový systém pro transport osob"
                        year="2023"
                        title="Transport osob"
                        bullets={[
                            'Objednávkový systém pro transport osob',
                            'Hlídá čas a upozorňuje jak řidiče, tak klienty na blížícím se času jízdy.',
                            'Psané v Symfony',
                        ]}
                        linkHref="https://abcnet.cz:10443"
                        linkText="Link"
                    />
                </Col>
            </Row>

            <Row className="gx-3">
                {/* Toyoda */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={toyodaImg}
                        title="Toyoda"
                        imgAlt="Automatizace procesů a obrazovka se statusy strojů – Toyoda"
                        year="2024"
                        bullets={[
                            'Automatizace procesů a zobrazovací obrazovka se statusy strojů.',
                            'Pro firmu Toyoda',
                            'Laravel 11 + javasript',
                        ]}
                    />
                </Col>

                {/* Pneuservis */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={pneuservis}
                        title="Pneuservis"
                        imgAlt="Objednávkový systém pro pneuservis"
                        year="2023"
                        bullets={[
                            'Objednávkový systém pro pneuservis',
                            'Psáno v čistém javasript + php',
                        ]}
                        linkHref="https://abcnet.cz/rezervace/?tokenOfServis=1234"
                        linkText="Link"
                    />
                </Col>

                {/* Restaurace */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={food}
                        imgAlt="Objednávkový systém pro restaurace napojený na platební bránu"
                        year="2023"
                        title="Restaurace"
                        bullets={[
                            'Objednávkový systém pro restaurace napojen na platební bránu',
                            'Psáno v čistém javasriptu + php',
                        ]}
                        linkHref="https://abcnet.cz/food/FatFuck/"
                        linkText="Link"
                    />
                </Col>
            </Row>

            <Row>
                {/* Sorelio */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={sorelio}
                        title="Sorelio"
                        imgAlt="Sorelio – práce na Laravelu pro rakouské zdravotníky"
                        year="2024"
                        bullets={[
                            'Ve firmě Sorelio s.r.o. jsem pracoval dva měsíce jako vývojář Laravel pro rakouské zdravotníky.',
                        ]}
                    />
                </Col>

                {/* Global+ */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={imgGlobalPlusWeb}
                        imgAlt="Global+ webové stránky"
                        title="Global"
                        year="2023"
                        bullets={[
                            'Global + webové stránky',
                        ]}
                    />
                </Col>

                {/* Instagram pro útulky */}
                <Col xs={12} md={4}>
                    <ProjectCard
                        imgSrc={animals}
                        imgAlt="Šablona pro psí útulky s administrací"
                        year="2023-2024"
                        bullets={[
                            '"Instagram pro psí útulky"',
                            'Projekt není dodělán',
                            'Šablona pro psí útulky s administrativou',
                            'Psáno v Laravel + react',
                        ]}
                    />
                </Col>
            </Row>
        </Container>


        <Container>
          <div className='textContent'>
              <h2>Jak probíhá vývoj softwaru
                    <motion.img
                        src={rocket} // Změň na cestu k tvému obrázku raketky
                        alt="Rocket"
                        initial="initial"
                        animate={inView ? 'animate' : 'initial'}
                        variants={rocketVariants}
                        transition={{ duration: 4 }}
                        style={{ width: '100px', height: '100px' }} // Nastav počáteční velikost raketky
                    />
            </h2>
          </div>
    </Container>



    <Container>
        <Row className="gx-3" ref={ref}>
            {wokrProgress.map((item, index) => (
            <Col
                key={item.id}
                xs={12}
                md={3}
                className="oneHowWillBee"
            >
                <motion.div
                initial="hidden"
                animate={inView ? 'visible' : 'hidden'}
                variants={itemVariants}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="oneHowWillBee"
                >
                <div className="oneNumber">
                    <h2>{item.id}</h2>
                </div>
                <h2>{item.title}</h2>
                </motion.div>
            </Col>
            ))}
        </Row>
    </Container>



      <Container style={{marginTop: 100, borderRadius: 25}}>
            <a href="#" target="_blank" style={{textDecoration: 'none'}}>
                <div className='buttonPlay' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, border:'1px solid #a3a3a3', borderRadius: 20, padding: 30, cursor: 'pointer', background: 'rgb(15,5,23', flexDirection: 'column', minHeight: 150}}>
                    <h2>
                        Cenu a čas zhotovení Vám rádi vyčíslíme podle projektu. Díky použití umělé inteligence při vývoji je cena mnohem nižší, než tomu bylo doposud.
                    </h2>
                </div>
            </a>
      </Container>





      <div style={{marginTop: 200, padding: 30, background: 'rgb(6,19,27)'}}>
            <Row >
                <Col xs={12} md={3} style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', marginBottom: 50}}>
                    <img alt="" src={abcnetLogo} style={{width: '100%'}}/>
                </Col>
                <Col xs={12} md={2}></Col>
                <Col xs={12} md={7} >
                    <div className='textContentRight'>
                        <h2 style={{color: 'rgb(51,154,222)'}}>Neváhejte nás kontaktovat</h2>
                        <br></br>
                        <p style={{color: 'white', fontSize: 18, margin: 0}}>Pavel Čuba | Vývojář</p>
                        <p style={{color: 'white', fontSize: 18, margin: 0}}>ABC NET s.r.o.</p>
                        <p style={{color: 'white', fontSize: 18, margin: 0}}>Tel: 602 448 912</p>
                        <p style={{color: 'white', fontSize: 18, margin: 0}}>Email: info@abcnet.cz</p>
                    </div>
                </Col>

            </Row>
      </div>

    </div>
  )
}

export default Main
